import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, Send, CheckCircle } from 'lucide-react';
import api from '../services/api';
import '../styles/Login.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao processar pedido.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <div className="login-logo">
            <img src="/logo.png" alt="BDA" style={{width:90,height:90,objectFit:'contain'}} />
          </div>
          <h1>Recuperar senha</h1>
          <p>Enviaremos um link de recuperação para seu email</p>
        </div>

        {sent ? (
          <div className="login-success">
            <CheckCircle size={36} color="#16A34A" />
            <h3>Verifique sua caixa de entrada</h3>
            <p>Se o email estiver cadastrado, você receberá um link para redefinir a senha em alguns minutos.</p>
            <Link to="/login" className="login-link-btn">
              <ArrowLeft size={15}/> Voltar ao login
            </Link>
          </div>
        ) : (
          <form className="login-form" onSubmit={handleSubmit}>
            <div className="login-field">
              <label htmlFor="forgot-email">Email da conta</label>
              <div className="login-input-wrap">
                <Mail size={16} />
                <input
                  id="forgot-email"
                  className="login-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="seu@email.com"
                  required
                  autoComplete="email"
                />
              </div>
            </div>

            {error && <div className="login-error">{error}</div>}

            <button type="submit" className="login-submit" disabled={loading}>
              {loading ? 'Enviando...' : (<><Send size={16}/> Enviar link</>)}
            </button>

            <Link to="/login" className="login-link">
              <ArrowLeft size={14}/> Voltar ao login
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
